module.exports = "<div class=\"filter_item_timeframe\" tabindex=\"-1\"></div>";